export const insertUrlParam = (key, value) => {
  if (window.history.pushState) {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    let newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + searchParams.toString();
    window.history.pushState({ path: newUrl }, '', newUrl);
  }
};

// The webapp is served from several domains (one per market area), so the
// backend needs to know which one the user is currently on, e.g. to build
// links in the emails it sends.
export const getClientAppUrl = () => {
  return window.location.origin || window.location.protocol + '//' + window.location.host;
};

export default {
  insertUrlParam,
  getClientAppUrl
};
